(() => {
  "use strict";
  if (window.__OPTI_COPYFIX_LOADED__) return;
  window.__OPTI_COPYFIX_LOADED__ = true;
  window.__OPTI_AVATAR_V1__ = true;

  const ROOT_ID = "opti-chatbot";
  const STORAGE_KEY = "opti_chat_session_v1";
  const WELCOME = {
    fr:"Bonjour 👋 Moi, c’est OPTI 🤖, l’assistant d’Optimus Pneus. Indique-moi la dimension de tes pneus (ex. 225/45 R17), ton véhicule ou le type de pneus que tu recherches, et je lance l’analyse.",
    en:"Hello 👋 I’m OPTI 🤖, the Optimus Pneus assistant. Tell me your tyre size (e.g. 225/45 R17), vehicle or tyre type and I’ll start the search.",
    de:"Hallo 👋 Ich bin OPTI 🤖, der Assistent von Optimus Pneus. Nennen Sie Reifengröße (z. B. 225/45 R17), Fahrzeug oder Reifentyp und ich starte die Suche.",
    es:"Hola 👋 Soy OPTI 🤖, el asistente de Optimus Pneus. Indícame la medida (p. ej. 225/45 R17), tu vehículo o el tipo de neumático y comenzaré la búsqueda.",
    it:"Ciao 👋 Sono OPTI 🤖, l’assistente di Optimus Pneus. Indicami la misura (es. 225/45 R17), il veicolo o il tipo di pneumatico e avvierò la ricerca.",
    nl:"Hallo 👋 Ik ben OPTI 🤖, de assistent van Optimus Pneus. Geef uw bandenmaat (bijv. 225/45 R17), voertuig of bandentype door en ik start de zoekopdracht."
  };
  const lang = String(document.documentElement.lang || (window.Shopify && window.Shopify.locale) || "fr").toLowerCase().split("-")[0];
  const NEW_WELCOME = WELCOME[lang] || WELCOME.fr;
  const scriptSrc = document.currentScript && document.currentScript.src ? document.currentScript.src : location.href;
  const AVATAR_URL = new URL("opti-avatar-white-final.webp", scriptSrc).href;

  function installStyles() {
    if (document.getElementById("opti-avatar-style")) return;
    const style = document.createElement("style");
    style.id = "opti-avatar-style";
    style.textContent = `
      .opti-chat__launcher-core,.opti-chat__avatar,.opti-chat__mini-avatar{padding:0!important;overflow:hidden!important;background:#fff!important;}
      .opti-chat__launcher-core img,.opti-chat__avatar img,.opti-chat__mini-avatar img{display:block;width:100%;height:100%;object-fit:cover;object-position:center;border:0;background:#fff!important;}
      .opti-chat__launcher-core img{border-radius:50%;}
      .opti-chat__avatar img{border-radius:12px;}
      .opti-chat__mini-avatar img{border-radius:8px;}
    `;
    document.head.appendChild(style);
  }

  function avatarize(el) {
    if (!el || el.dataset.optiAvatar === "1") return;
    el.dataset.optiAvatar = "1";
    el.textContent = "";
    const img = document.createElement("img");
    img.src = AVATAR_URL;
    img.alt = "";
    img.decoding = "async";
    img.setAttribute("aria-hidden", "true");
    el.appendChild(img);
  }

  function applyAvatars(root) {
    if (!root) return;
    root.querySelectorAll(".opti-chat__launcher-core,.opti-chat__avatar,.opti-chat__mini-avatar").forEach(avatarize);
  }

  function stripRepeatedWelcome(raw) {
    let text = String(raw || "").trim();
    if (!text) return "";
    const patterns = [
      /^Bonjour\s+à\s+toi,\s*Terrien\s*👋?\s*Moi,\s*c[’']est\s+OPTI\s*🤖?,?\s*l[’']assistant\s+intelligent\s+d[’']Optimus\s+Pneus\.\s*/i,
      /^Bonjour\s+à\s+toi,\s*Terrien[\s\S]{0,180}?Moi,\s*c[’']est\s+OPTI[\s\S]{0,180}?Optimus\s+Pneus\.\s*/i
    ];
    for (const pattern of patterns) text = text.replace(pattern, "").trim();
    return text;
  }

  function cleanStoredHistory() {
    try {
      const parsed = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || "[]");
      if (!Array.isArray(parsed)) return;
      const cleaned = parsed.map((item) => {
        if (!item || typeof item !== "object") return null;
        const role = item.role;
        let content = typeof item.content === "string" ? item.content : "";
        if (role === "assistant") content = stripRepeatedWelcome(content);
        if (!content.trim()) return null;
        return { role, content };
      }).filter(Boolean);
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(cleaned));
    } catch (_) {}
  }

  function fixMessages(root) {
    const messages = root.querySelector(".opti-chat__messages");
    if (!messages) return;
    const assistantRows = Array.from(messages.querySelectorAll(".opti-chat__message--assistant"));
    assistantRows.forEach((row, index) => {
      const bubble = row.querySelector(".opti-chat__bubble");
      if (!bubble || row.classList.contains("opti-chat__typing")) return;
      const current = String(bubble.textContent || "").trim();
      if (!current) return;
      if (index === 0 && /Bonjour\s+à\s+toi,\s*Terrien/i.test(current) && /mission\s+pneumatique/i.test(current)) {
        bubble.textContent = NEW_WELCOME;
        return;
      }
      const cleaned = stripRepeatedWelcome(current);
      if (cleaned && cleaned !== current) bubble.textContent = cleaned;
    });
  }

  function install(root) {
    installStyles();
    cleanStoredHistory();
    fixMessages(root);
    applyAvatars(root);
    const observer = new MutationObserver(() => {
      fixMessages(root);
      applyAvatars(root);
      cleanStoredHistory();
    });
    observer.observe(root, { childList: true, subtree: true, characterData: true });
  }

  const existing = document.getElementById(ROOT_ID);
  if (existing) return install(existing);
  const rootObserver = new MutationObserver(() => {
    const root = document.getElementById(ROOT_ID);
    if (!root) return;
    rootObserver.disconnect();
    install(root);
  });
  rootObserver.observe(document.documentElement, { childList: true, subtree: true });
})();
